import { BaseScrollable } from './__internal__/BaseScrollable';
import { ScrollableProps } from './';
import { createElement, forwardRef } from 'react';

export const Scrollable = forwardRef<HTMLDivElement, ScrollableProps>(function Scrollable(
  props,
  ref
) {
  return <BaseScrollable {...props} ref={ref} />;
});
